export const SET_USER = 'SET_USER';
export const SET_USER_BUS = 'SET_USER_BUS';
export const LOGOUT_USER = 'LOGOUT_USER';
export const API_TOKEN = "api_token";

export function setUser(user) {
    return {
        type: SET_USER,
        user
    };
}
export function setUserBus(user, passenger, seats) {
    return {
        type: SET_USER_BUS,
        user,
        passenger,
        seats
    };
}
export function logoutUser() {
    removeToken();
    return {
        type: LOGOUT_USER,
    };
}


export function setToken(api_token) {
    localStorage.setItem(API_TOKEN, api_token);
}

export function removeToken() {
    localStorage.removeItem(API_TOKEN);
}

export function loadToken() {
    return localStorage.getItem(API_TOKEN);
}







// WEBPACK FOOTER //
// ./src/redux/actions/user.js